import { Text, Button, Img } from '../../Atoms';
import HospitalizationImage from '../../assets/img/Hospitalization_image.png';
function TemplateHospitalisationStep1 (props) {
  const goTo = ()=>{
    window.open("https://esante.gouv.fr/roc", "_blank")
  }
  return (
    <div className='template-document template-send-document template-scroll'>
      <Text text="Hospitalisation" className="title-document" />
      {props.responseApi &&(
        <div className='container-hospitalisation'>
          <div className='hospitalization-organism-box'>
            <p className='hospitalisation-response'>{props.responseApi}</p>
            <Button
              onClick={goTo}
              text='En savoir plus'
              className='hospitalization-organism-button cartetp-organism-button__partage-margin'
            />
          </div>
          <div className='hospitalization-img-container'>
            <Img src={HospitalizationImage} className='cartetp-organism-img' />
          </div>
        </div>
      )}
    </div>
  );
}

export default TemplateHospitalisationStep1;
